<template>
  <div class="template-messages-container">
    <v-container>
      <div class="day" v-for="day in daysMerged" :key="day.index" :class="isProcedureDateRelated && day.index==0 ? 'with-procedure' : ''">
        <div class="day-index" :class="isProcedureDateRelated ? 'procedure-related' : ''">
          <div class="day-index--wrapper">
            <div class="day-index--day">Day <span>{{day.index>0 ? '+' : ''}}{{day.index}}</span></div>
            <div class="day-index--procedure" v-if="isProcedureDateRelated && day.index==0">Target</div>
          </div>
        </div>
        <draggable 
          group="messages" 
          @end="dragEnd"
          @start="dragStart"
          :move="checkMove" 
          :list="day.messages" 
          :key="'column-'+day.index"
          class="day-column">
          <div class="day-message" v-for="(column,index) in day.messages" :key="'column-'+day.index+'-'+index">
            <v-tooltip bottom open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                  v-on="on">{{column.message.length > 15 ? column.message.substring(0,12) + "..." : column.message}}</span>
              </template>
              <span>{{column.message}}</span>
            </v-tooltip>
            <span class="day-message-time">{{formatTime(column.time)}}</span>
            <v-menu rounded offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  elevation="0"
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="day-message--edit"
                >
                  <v-icon>bhi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list class="library-folder__more--menu">
                <v-list-item link dense @click="$emit('edit-message', day.messages[index], day.index)">
                  <v-list-item-icon>
                    <v-icon>bhi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                        Edit
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link dense @click="$emit('copy-message', day.messages[index], day.index)">
                  <v-list-item-icon>
                    <v-icon>bhi-copy</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                        Duplicate
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link dense @click="$emit('delete-message', day.messages[index], day.index)">
                  <v-list-item-icon>
                    <v-icon>bhi-trash</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                        Remove
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </draggable>
        <div class="day-column additional">
          <v-btn
            color="#F6F8FB"
            width="120"
            height="36"
            elevation="0"
            @click="$emit('new-message', day.index)">
            <v-icon
              color="#DBDDE0"
              size="12">bhi-plus</v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: "TemplateMessagesContainer",
  data() {
    return {
      columns: [],
      daysMerged: false
    }
  },
  components: {
    draggable
  },
  props: {
    days: {
      type: Array,
      default: () => { return [] }
    },
    isProcedureDateRelated: {
      type: Boolean,
      default: false 
    },
    forceRedraw: {
      type: Number,
      default: 0
    }
  },
  mounted() {
  },
  watch: {
    days: {
      handler(newValue, oldValue) {
        if (newValue) this.daysMerged = this.mergeDays()
      },
      // deep:true
    },
    forceRedraw() {
      this.daysMerged = this.mergeDays()
    }
  },
  computed: {
    daysDefinitions() {
      let arr = []
      let index = 0
      if (this.isProcedureDateRelated) index = 45

      for (let i=0; i<90; i++) {
        arr[i]={index: i-index}
      }
      return arr
    },
  },
  methods: {
    mergeDays() {
      let arr = []
      this.setColumns(0)
      this.daysDefinitions.forEach(el=>{
        let tmp = {index:el.index, messages: []}
        let tmp2 = this.days.find(item=> item.index==el.index)
        if (tmp2 && tmp2.messages) {
          tmp.messages = tmp2.messages.sort((a,b)=>(a.time>b.time)?1:((b.time>a.time)?-1:0))
          if (tmp.messages.length > this.columns.length || !this.columns) this.setColumns(tmp.messages.length)
        }
        arr.push(tmp)
      })
      return arr
    },
    calculateColumns() {
      let max = 0
      this.daysMerged.forEach(el=>{
        if (el.messages.length > this.columns.length || !this.columns) {
          this.setColumns(el.messages.length)
        }
        if (el.messages.length > max) max = el.messages.length
      })
      if (max > 0 && max < this.columns.length) this.setColumns(max)
    },
    setColumns(length) {
      if (length>0) {
        this.columns = Array.from(Array(length).keys())
      } else {
        this.columns = false
      }
    },
    formatTime(time) {
      return this.$moment(time, "HH:mm:ss").format("hh:mm A")
    },
    checkMove: function(evt){
    },
    dragEnd(ev) {
      this.calculateColumns()
      this.$emit('update-messages',this.daysMerged)
    },
    dragStart(ev) {
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/variables";
.template-messages-container {
  background: $bh-white;
  width: 100%;
  max-height: calc(100vh - 80px);
  overflow: auto;
  .container {
    display: table;
  }
  .day {
    display: table-row;
    align-items:center;
    position: relative;
    white-space: nowrap;
    &::before {
      content: "";
      position: absolute;
      bottom:0;
      width: 100%;
      border-bottom: 1px solid $bh-blue--4;
      left: 0;
    }
    &.with-procedure {
      position: relative;
      &::after {
        background: $bh-red--light;
        content: '';
        opacity: 0.2;
        position: absolute;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
      }
      * {
        z-index: 1;
      }
    }
    &-index {
      display: table-cell;
      vertical-align: middle;
      align-items: center;
      white-space: nowrap;
      &.procedure-related {
        width: 120px;
      }
      &--wrapper {
        display: flex;
        align-items: center;
      }
      &--day {
        text-align: left;
        font-size: 9px;
        padding:0 5px;
        color: $bh-gray--2;
        span {
          display: block;
          font-weight: bold;
          font-size: 12px;
        }  
      }
      &--procedure {
        color: $bh-white;
        background: $bh-red;
        opacity: 0.8;
        margin-left: 10px;
        margin-right: 10px;
        border-radius: 22px;
        width: 72px;
        text-align: center;
        line-height: 26px;
        font-size: 9px;
        text-transform: uppercase;
        font-weight: bold;
      }
    }
    &-column {
      display: table-cell;
      vertical-align: middle;
      padding:6px 0;
      min-width: 300px;
      &.additional {
        width:99%;
        padding-left: 10px;
      }
    }
    &-message {
      background: $bh-blue--2;
      display: inline-block;
      color: $bh-white;
      height: 36px;
      font-size: 12px;
      padding: 5px;
      line-height: 1;
      font-weight: bold;
      border-radius: 8px;
      position: relative;
      cursor: default;
      width: 120px;
      margin:1px 5px;
      &-time {
        font-size: 9px;
        margin-top:2px;
        font-weight: normal;
        opacity: 0.6;
        display: block;
      }
      &--edit {
        position: absolute;
        right: 0;
        top: 2px;
        .v-icon {
          transform: rotate(90deg);
          color: $bh-white;
        }
      }
    }
  }
}
</style>
